import { useQuery } from '@tanstack/react-query'
import { ApiKey } from 'features/incidents/components/enums'
import { axios } from 'lib/axios'
import { endpoints } from 'utils/endpoints'
export type GetMISPParams = {
  search: string
  isChainLinkCall: boolean
  isEvaluationStatusEDR: boolean
}

export const fetchMispData = (params: GetMISPParams) => {
  return axios.get(endpoints.MISP_API, { params })
}
export const useFetchMispData = (params: GetMISPParams) => {
  return useQuery([ApiKey.MISP, params], () => fetchMispData(params), {
    enabled: params.isEvaluationStatusEDR,
  })
}
